import './portfolio.css'

import BrandsCarousel from "../../components/carousels/brands-carousel";
import ContactForm from "../../components/forms/contact-form";
import ProductPartners from "../../components/product-partners";

import PortfolioHeroBanner from "./components/hero";
import PortfolioCards from "./components/portfolio-cards";


const Portfolio = () => {
    return (
        <section className="portfolio-layout-wrapper">
            <PortfolioHeroBanner />
            <BrandsCarousel />
            <PortfolioCards />
            <ContactForm />
            <ProductPartners />
        </section>
    )
}

export default Portfolio